import { render, staticRenderFns } from "./QolInterpretation.vue?vue&type=template&id=48078900&scoped=true"
import script from "./QolInterpretation.vue?vue&type=script&lang=js"
export * from "./QolInterpretation.vue?vue&type=script&lang=js"
import style0 from "./QolInterpretation.vue?vue&type=style&index=0&id=48078900&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48078900",
  null
  
)

export default component.exports